var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessAlarmRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_25759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8693 15.2501L12.4993 13.2501V8.72014C12.4993 8.32014 12.1793 8.00014 11.7793 8.00014H11.7193C11.3193 8.00014 10.9993 8.32014 10.9993 8.72014V13.4401C10.9993 13.7901 11.1793 14.1201 11.4893 14.3001L15.1393 16.4901C15.4793 16.6901 15.9193 16.5901 16.1193 16.2501C16.3293 15.9001 16.2193 15.4501 15.8693 15.2501ZM21.1793 5.01014L18.0993 2.45014C17.6793 2.10014 17.0493 2.15014 16.6893 2.58014C16.3393 3.00014 16.3993 3.63014 16.8193 3.99014L19.8893 6.55014C20.3093 6.90014 20.9393 6.85014 21.2993 6.42014C21.6593 6.00014 21.5993 5.37014 21.1793 5.01014ZM4.09927 6.55014L7.16927 3.99014C7.59927 3.63014 7.65927 3.00014 7.29927 2.58014C6.94927 2.15014 6.31927 2.10014 5.89927 2.45014L2.81927 5.01014C2.39927 5.37014 2.33927 6.00014 2.69927 6.42014C3.04927 6.85014 3.67927 6.90014 4.09927 6.55014ZM11.9993 4.00014C7.02927 4.00014 2.99927 8.03014 2.99927 13.0001C2.99927 17.9701 7.02927 22.0001 11.9993 22.0001C16.9693 22.0001 20.9993 17.9701 20.9993 13.0001C20.9993 8.03014 16.9693 4.00014 11.9993 4.00014ZM11.9993 20.0001C8.13927 20.0001 4.99927 16.8601 4.99927 13.0001C4.99927 9.14014 8.13927 6.00014 11.9993 6.00014C15.8593 6.00014 18.9993 9.14014 18.9993 13.0001C18.9993 16.8601 15.8593 20.0001 11.9993 20.0001Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_25759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessAlarmRed);
export default __webpack_public_path__ + "static/media/access_alarm_red.d8dc2dbb25ad1a6ea8884bc9f5fa178e.svg";
export { ForwardRef as ReactComponent };